import { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

const TOOLS = [
  "Intentional Living Planner",
  "Family Travel Toolkit",
  "Home Rhythms & Systems",
];

export default function ToolsPanel() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email, source: "digital_tools" });
      toast.success(data.message || "You'll be the first to know!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="panel sec-tools" id="tools" data-testid="panel-tools">
      <div className="tools-inner">
        <div className="sec-eyebrow reveal" style={d(0)}>Coming Soon</div>
        <h2 className="sec-h reveal" style={d(1)}>
          Digital tools to help you <em>design your days.</em>
        </h2>
        <p className="sec-sub reveal" style={d(2)}>
          Thoughtfully made guides, planners, and templates for intentional living are on the way.
          Be the first to know when they launch.
        </p>

        <ul className="tools-list reveal" style={d(3)}>
          {TOOLS.map((t) => (
            <li className="tool-chip" key={t}>
              <Sparkles size={15} strokeWidth={1.6} /> {t}
            </li>
          ))}
        </ul>

        <form className="tools-form reveal" style={d(4)} data-testid="tools-notify-form" onSubmit={submit}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            aria-label="Email address"
            data-testid="tools-email-input"
          />
          <button type="submit" disabled={loading} data-testid="tools-submit-button">
            {loading ? "Saving…" : "Notify Me"}
          </button>
        </form>
      </div>
    </section>
  );
}
